import React from 'react'
import { Chip } from 'components/ui'
import keys from 'constants/keys'
import { useExecutionText } from '../../hooks/useExecutionText'
const statusColors = {
  neutral: { color: '#6c757b', bg: '#f1f3f5' },
  blue: { color: '#3f6fa8', bg: '#e6eef8' },
  amber: { color: '#a3711f', bg: '#fff5e5' },
  green: { color: '#5b7a2e', bg: '#eaf3e6' },
  red: { color: '#c1453f', bg: '#fdeaea' },
  purple: { color: '#6b4fa8', bg: '#efe9fb' },
}

export const ExecutionStatus: React.FC<{ status?: number; approval?: boolean; size?: 'sm' | 'md' }> = ({
  status,
  approval,
  size = 'sm',
}) => {
  const t = useExecutionText()
  const s = keys.TASK_STATUSES
  let label = t.notStarted
  let tone: keyof typeof statusColors = 'neutral'
  if (status === s.INPROGRESS.value) {
    label = t.inProgress
    tone = 'blue'
  }
  if (status === s.DONE.value) {
    label = approval ? t.awaitingReview : t.done
    tone = approval ? 'amber' : 'green'
  }
  if (status === s.APPROVED.value || status === s.APPROVED_WITH_RESERVATION.value) {
    label = t.approved
    tone = 'green'
  }
  if (status === s.DISAPPROVED.value) {
    label = t.rejected
    tone = 'red'
  }
  if (status === s.SKIPPED.value) label = t.skipped
  if (status === s.REVIEWED_BY_AI.value) {
    label = t.aiReviewed
    tone = 'purple'
  }
  return <Chip label={<>{label}</>} size={size} radius="7px" border="0" {...statusColors[tone]} />
}
